// extracted by mini-css-extract-plugin
export default {"root":"LazxrtAKpXyz4Kksr_k8"};